import { get } from './utils';
import { Dataset } from '~/types/gists/conditions';

const fetchDataSets = async (): Promise<Dataset[]> => await get('/conditions/data-sets');

export const conditions = {
  fetchDataSets
};
